import React from "react";

function clean(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value).replace(/_/g, " ");
}

function StateCard({ side, technical, state, active, onOpen }) {
  const orientation = clean(state.orientation, "unresolved").toLowerCase();

  return (
    <article className={`rr-delta-state-card ${technical.toLowerCase()} ${active ? "current" : ""}`}>
      <header>
        <div>
          <span className="v25a-eyebrow">CONFIGURATION {side}</span>
          <small>{technical}</small>
        </div>
        {active ? <span className="rr-current-config">CURRENT</span> : null}
      </header>

      <h3>{clean(state.configurationLabel, clean(state.configurationId, "Configuration"))}</h3>

      <div className="rr-delta-state-orientation">
        <span className={orientation}>{orientation}</span>
      </div>

      <div className="rr-delta-state-receipts">
        <span><b>{state.rootCount ?? "—"}</b>independent roots</span>
        <span><b>{state.pathwayCount ?? "—"}</b>pathways</span>
        <span><b>{state.convergence ?? "—"}</b>convergence</span>
      </div>

      {state.id && typeof onOpen === "function" ? (
        <button type="button" onClick={() => onOpen(state.id)}>
          Inspect Configuration {side} →
        </button>
      ) : null}
    </article>
  );
}

export default function DeltaTopology({
  capabilityLabel,
  left,
  right,
  currentStateId,
  onOpenState,
}) {
  return (
    <section className="rr-delta-topology">
      <div className="rr-compare-reading-guide">
        <span className="v25a-eyebrow">HOW TO READ THIS</span>
        <p>
          The capability in the center stays fixed. Configuration A and
          Configuration B are two different research configurations around it.
          <b> They are not before and after.</b>
        </p>
      </div>

      <div className="rr-delta-topology-grid">
        <StateCard
          side="A"
          technical="K0"
          state={left}
          active={left.id === currentStateId}
          onOpen={onOpenState}
        />

        <div className="rr-delta-capability-center">
          <span className="v25a-eyebrow">SAME CAPABILITY</span>
          <i>●</i>
          <h3>{capabilityLabel}</h3>
          <small>
            This identity remains fixed while the surrounding topology changes.
          </small>
          <div className="rr-delta-links" aria-hidden="true">
            <span />
            <b>COMPARE</b>
            <span />
          </div>
        </div>

        <StateCard
          side="B"
          technical="K1"
          state={right}
          active={right.id === currentStateId}
          onOpen={onOpenState}
        />
      </div>
    </section>
  );
}
